// extracted by mini-css-extract-plugin
export default {"Wall":"Wall_Wall__g6mCK","WallImage":"Wall_WallImage__bUSts","WallImageWrapper":"Wall_WallImageWrapper__6CWDE"};